export interface ComicItem {
  id: number;
  title: string;
  category: string;
  tags: string[];
  rating: number;
  status: string;
  chapters: string;
  intro: string;
  highlight: string;
  cover: string;
}

export interface HealingPick {
  id: number;
  title: string;
  tagline: string;
  reason: string;
  image: string;
}

export const categories = [
  "全部",
  "萌系日常",
  "治愈温情",
  "软萌画风",
  "温馨剧情",
  "可爱角色",
];

export const comics: ComicItem[] = [
  {
    id: 1,
    title: "软软的猫爪面包店",
    category: "软萌画风",
    tags: ["软萌画风", "治愈温情"],
    rating: 9.6,
    status: "连载中",
    chapters: "已更新至 128 话",
    intro: "一家藏在巷子里的面包店，主理人是一只戴厨师帽的橘猫。每天清晨出炉的可颂会冒出暖香，客人是形形色色的小动物，故事在麦香与阳光下慢慢发酵。",
    highlight: "画风软糯，温馨剧情让人会心一笑",
    cover: "https://readdy.ai/api/search-image?query=kawaii%20cute%20healing%20manga%20cover%20illustration%20of%20a%20fluffy%20orange%20cat%20chef%20holding%20a%20fresh%20croissant%20in%20a%20cozy%20small%20bakery%2C%20warm%20cream%20and%20soft%20peach%20pastel%20colors%2C%20gentle%20anime%20line%20art%2C%20wholesome%20cozy%20atmosphere%2C%20clean%20soft%20background&width=600&height=800&seq=cover-bakery&orientation=portrait",
  },
  {
    id: 2,
    title: "今天也想赖床",
    category: "萌系日常",
    tags: ["萌系日常", "可爱角色"],
    rating: 9.4,
    status: "连载中",
    chapters: "已更新至 96 话",
    intro: "少女和她的猫之间关于起床、早餐与小小撒娇的日常。每话都很短，却能把一天的心情变得柔软，是适合睡前翻两页的暖心读物。",
    highlight: "可爱角色互动超治愈",
    cover: "https://readdy.ai/api/search-image?query=kawaii%20cute%20manga%20illustration%20of%20a%20sleepy%20girl%20hugging%20a%20plump%20cat%20under%20a%20fluffy%20blanket%20in%20soft%20morning%20light%2C%20warm%20cream%20and%20gentle%20peach%20pastel%20tones%2C%20soft%20anime%20art%2C%20cozy%20wholesome%20mood%2C%20clean%20background&width=600&height=800&seq=cover-lazy&orientation=portrait",
  },
  {
    id: 3,
    title: "治愈系便利店的日常",
    category: "治愈温情",
    tags: ["治愈温情", "温馨剧情"],
    rating: 9.2,
    status: "连载中",
    chapters: "已更新至 145 话",
    intro: "开在街角二十四小时不熄灯的便利店，店员猫和深夜顾客之间交换着彼此的疲惫与善意。一碗关东煮、一句晚安，就足以治愈失眠的夜晚。",
    highlight: "温馨剧情缓缓流淌",
    cover: "https://readdy.ai/api/search-image?query=cute%20healing%20manga%20illustration%20of%20a%20cozy%20convenience%20store%20interior%20at%20night%20with%20a%20friendly%20cat%20shopkeeper%20and%20warm%20lights%2C%20soft%20cream%20and%20warm%20amber%20tones%2C%20gentle%20anime%20art%20style%2C%20wholesome%20cozy%20atmosphere%2C%20clean%20background&width=600&height=800&seq=cover-store&orientation=portrait",
  },
  {
    id: 4,
    title: "花店老板的日记",
    category: "温馨剧情",
    tags: ["温馨剧情", "软萌画风"],
    rating: 9.0,
    status: "已完结",
    chapters: "全 60 话",
    intro: "不善言辞的花店老板与他的猫，用花语为小镇的人们传情达意。每一朵花背后都藏着一段细腻心事，缓缓诉说着关于温柔与告别。",
    highlight: "剧情细腻，软萌画风温柔",
    cover: "https://readdy.ai/api/search-image?query=cute%20healing%20manga%20illustration%20of%20a%20flower%20shop%20with%20a%20gentle%20shopkeeper%20and%20a%20cat%20among%20blooming%20pink%20and%20cream%20flowers%2C%20soft%20pastel%20anime%20art%2C%20warm%20wholesome%20mood%2C%20clean%20soft%20background&width=600&height=800&seq=cover-flower&orientation=portrait",
  },
  {
    id: 5,
    title: "猫猫茶馆物语",
    category: "可爱角色",
    tags: ["可爱角色", "萌系日常"],
    rating: 9.5,
    status: "连载中",
    chapters: "已更新至 88 话",
    intro: "深山里的茶馆只接待心情疲惫的旅人。掌柜猫泡一杯温茶，听客人讲他们的故事。茶香氤氲里，烦恼悄悄化作缕缕水汽飘散。",
    highlight: "可爱角色满满，氛围治愈",
    cover: "https://readdy.ai/api/search-image?query=cute%20healing%20manga%20illustration%20of%20a%20cozy%20teahouse%20with%20cats%20serving%20warm%20tea%20to%20weary%20travelers%2C%20soft%20cream%20and%20warm%20coral%20pastel%20tones%2C%20gentle%20anime%20art%2C%20wholesome%20serene%20atmosphere%2C%20clean%20background&width=600&height=800&seq=cover-teahouse&orientation=portrait",
  },
  {
    id: 6,
    title: "雨天请喝热可可",
    category: "治愈温情",
    tags: ["治愈温情", "温馨剧情"],
    rating: 9.1,
    status: "连载中",
    chapters: "已更新至 72 话",
    intro: "每个下雨天，窗边的小店里总会准备一大壶热可可。雨声、奶泡和陌生人之间偶然的寒暄，组成了治愈向日常最温柔的注脚。",
    highlight: "雨天限定，格外治愈",
    cover: "https://readdy.ai/api/search-image?query=cute%20healing%20manga%20illustration%20of%20a%20rainy%20window%20with%20a%20cozy%20cup%20of%20hot%20cocoa%20with%20marshmallows%20and%20a%20small%20cat%20watching%20the%20rain%2C%20soft%20warm%20cream%20and%20amber%20tones%2C%20gentle%20anime%20art%2C%20wholesome%20cozy%20mood%2C%20clean%20background&width=600&height=800&seq=cover-cocoa&orientation=portrait",
  },
  {
    id: 7,
    title: "邻居家的奶油小狗",
    category: "可爱角色",
    tags: ["可爱角色", "萌系日常"],
    rating: 9.3,
    status: "连载中",
    chapters: "已更新至 110 话",
    intro: "搬家后遇到一只总爱翻墙来打招呼的奶油色小狗，从此每天都有惊喜。软乎乎的团子、摇不停的尾巴，把都市的孤独一点点捂暖。",
    highlight: "萌到犯规的可爱角色",
    cover: "https://readdy.ai/api/search-image?query=cute%20healing%20manga%20illustration%20of%20an%20adorable%20cream%20colored%20fluffy%20puppy%20peeking%20over%20a%20garden%20fence%2C%20soft%20cream%20and%20peach%20pastel%20tones%2C%20gentle%20anime%20art%2C%20wholesome%20playful%20mood%2C%20clean%20soft%20background&width=600&height=800&seq=cover-puppy&orientation=portrait",
  },
  {
    id: 8,
    title: "被窝星球漫游指南",
    category: "软萌画风",
    tags: ["软萌画风", "可爱角色"],
    rating: 9.2,
    status: "连载中",
    chapters: "已更新至 64 话",
    intro: "下班后只想钻进被窝的少女，脑内开启了一场软绵绵的星球漫游。每话都是对现代人疲惫日常的温柔抚慰，画风软到心底。",
    highlight: "软萌画风一网打尽",
    cover: "https://readdy.ai/api/search-image?query=kawaii%20cute%20manga%20illustration%20of%20a%20girl%20floating%20among%20fluffy%20pillow%20clouds%20in%20a%20dreamy%20soft%20bedroom%20cosmos%2C%20soft%20cream%20and%20gentle%20pink%20pastel%20tones%2C%20dreamy%20anime%20art%2C%20cozy%20wholesome%20mood%2C%20clean%20background&width=600&height=800&seq=cover-planet&orientation=portrait",
  },
  {
    id: 9,
    title: "四季食堂手帐",
    category: "温馨剧情",
    tags: ["温馨剧情", "治愈温情"],
    rating: 9.0,
    status: "已完结",
    chapters: "全 80 话",
    intro: "跟着季节流转的小食堂，用当季食材烹饪治愈料理。春樱秋枫、夏蝉冬雪，食物与人与人之间的牵绊在四季里慢慢升温。",
    highlight: "剧情温暖，治愈系佳品",
    cover: "https://readdy.ai/api/search-image?query=cute%20healing%20manga%20illustration%20of%20a%20seasonal%20cozy%20dining%20room%20table%20with%20steaming%20warm%20soup%20and%20seasonal%20ingredients%2C%20soft%20cream%20and%20warm%20coral%20tones%2C%20gentle%20anime%20art%2C%20wholesome%20cozy%20mood%2C%20clean%20background&width=600&height=800&seq=cover-canteen&orientation=portrait",
  },
  {
    id: 10,
    title: "毛茸茸救援队",
    category: "萌系日常",
    tags: ["萌系日常", "可爱角色"],
    rating: 9.4,
    status: "连载中",
    chapters: "已更新至 102 话",
    intro: "一只由猫咪和狗狗组成的特别救援队，专门解救被卡住的、迷路的、心情低落的小动物。每次出动都又好笑又暖心。",
    highlight: "萌系日常欢乐满点",
    cover: "https://readdy.ai/api/search-image?query=cute%20healing%20manga%20illustration%20of%20a%20team%20of%20fluffy%20cats%20and%20dogs%20on%20a%20tiny%20rescue%20mission%20helping%20a%20small%20animal%2C%20soft%20cream%20and%20peach%20pastel%20tones%2C%20gentle%20anime%20art%2C%20wholesome%20playful%20mood%2C%20clean%20background&width=600&height=800&seq=cover-rescue&orientation=portrait",
  },
  {
    id: 11,
    title: "慢吞吞邮局的信",
    category: "治愈温情",
    tags: ["治愈温情", "温馨剧情"],
    rating: 9.1,
    status: "连载中",
    chapters: "已更新至 58 话",
    intro: "这座邮局寄信很慢，却会认真对待每一封信。那些来不及说出口的话、藏在字里行间的心意，都被温柔地送到对的人手中。",
    highlight: "慢节奏治愈，剧情细腻",
    cover: "https://readdy.ai/api/search-image?query=cute%20healing%20manga%20illustration%20of%20a%20small%20cozy%20post%20office%20with%20a%20cat%20mailman%20carrying%20a%20letter%2C%20soft%20cream%20and%20warm%20amber%20pastel%20tones%2C%20gentle%20anime%20art%2C%20wholesome%20heartwarming%20mood%2C%20clean%20background&width=600&height=800&seq=cover-post&orientation=portrait",
  },
  {
    id: 12,
    title: "午后的读书角",
    category: "软萌画风",
    tags: ["软萌画风", "治愈温情"],
    rating: 9.0,
    status: "连载中",
    chapters: "已更新至 47 话",
    intro: "阳光斜斜洒进图书馆的角落，猫馆长和它的朋友们分享着好书与心事。静谧的午后，文字与画风一起温柔地包裹住读者。",
    highlight: "画风软萌，适合静心阅读",
    cover: "https://readdy.ai/api/search-image?query=cute%20healing%20manga%20illustration%20of%20a%20cozy%20library%20corner%20with%20a%20cat%20librarian%20reading%20a%20book%20in%20warm%20afternoon%20sunlight%2C%20soft%20cream%20and%20gentle%20peach%20tones%2C%20gentle%20anime%20art%2C%20wholesome%20serene%20mood%2C%20clean%20background&width=600&height=800&seq=cover-reading&orientation=portrait",
  },
];

export const healingPicks: HealingPick[] = [
  {
    id: 1,
    title: "暖炉边的团子组曲",
    tagline: "冬天最该看的治愈漫画",
    reason: "冷天里围炉烤棉花糖的一家人与猫，软萌画风配上温馨剧情，把寒气都暖化了。",
    image: "https://readdy.ai/api/search-image?query=cute%20healing%20manga%20illustration%20of%20a%20cozy%20family%20and%20cats%20gathered%20around%20a%20warm%20hearth%20roasting%20marshmallows%2C%20soft%20cream%20and%20warm%20coral%20pastel%20tones%2C%20gentle%20anime%20art%2C%20wholesome%20cozy%20atmosphere%2C%20clean%20background&width=800&height=560&seq=heal-hearth&orientation=landscape",
  },
  {
    id: 2,
    title: "慢慢走也没关系",
    tagline: "治愈系日常慢生活推荐",
    reason: "一个什么都慢半拍的村庄，教会读者偶尔停下来。治愈向作品里少见的松弛与温柔。",
    image: "https://readdy.ai/api/search-image?query=cute%20healing%20manga%20illustration%20of%20a%20tranquil%20slow%20living%20village%20with%20a%20girl%20and%20cat%20walking%20under%20cherry%20blossoms%2C%20soft%20cream%20and%20gentle%20pink%20pastel%20tones%2C%20gentle%20anime%20art%2C%20wholesome%20serene%20mood%2C%20clean%20background&width=800&height=560&seq=heal-slow&orientation=landscape",
  },
  {
    id: 3,
    title: "星星掉进了奶茶杯",
    tagline: "可爱角色与温馨剧情",
    reason: "少女经营的小小奶茶店，每晚把一颗小心愿泡进杯里。可爱角色满载，剧情甜而不腻。",
    image: "https://readdy.ai/api/search-image?query=cute%20healing%20manga%20illustration%20of%20a%20cozy%20small%20milk%20tea%20shop%20with%20a%20girl%20and%20cat%20making%20glowing%20cups%20with%20tiny%20stars%2C%20soft%20cream%20and%20warm%20coral%20pastel%20tones%2C%20gentle%20anime%20art%2C%20wholesome%20cozy%20mood%2C%20clean%20background&width=800&height=560&seq=heal-boba&orientation=landscape",
  },
];